import React from 'react';
import Badge from '../DataTableFields/Badge';

const BraceletBadge = ({ value }) => {
  return (
    <div className={value === true ? 'master-yes' : 'master-no'}>
      <Badge>{value === true ? 'SI' : 'NO'}</Badge>
    </div>
  );
};

export default BraceletBadge;
